export default "__VITE_ASSET__yx0g2iVZ__"